/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import HtmlReactParser from "html-react-parser"

const author = "@westonbaker"

const generatePageTitle = (showSiteTitle, titleLocation, siteTitle) => {
  if (showSiteTitle === false) return `%s`

  return titleLocation === "start" ? `${siteTitle} | %s` : `%s | ${siteTitle}`
}

function SEO({
  siteTitle,
  metaDescription,
  socialShare,
  favicon,
  lang,
  meta,
  title,
  keywords,
  pageDescription,
  showSiteTitleInPageTitle,
  siteTitleLocationInPageTitle,
  canonicalLink,
  htmlSnippets,
}) {
  if (!metaDescription) {
    metaDescription = "You can edit this site description in Site Settings"
  }
  let image = "/social-share.jpg"
  if (socialShare) {
    image = socialShare.url
  }
  if (keywords === null || keywords === undefined) {
    keywords = ""
  }
  let description
  if (pageDescription !== null && pageDescription !== undefined) {
    description = pageDescription
  } else {
    description = metaDescription
  }

  const renderSnippets = []
  htmlSnippets?.map(snippet => {
    renderSnippets.push(
      HtmlReactParser(snippet.dataObj.html.replace(/\n/g, ""))
    )
  })

  const renderScripts = renderSnippets
    .filter(tag => tag.type === "script")
    .map(snippet => {
      const { type, dangerouslySetInnerHTML } = snippet.props
      return <script type={type}>{dangerouslySetInnerHTML.__html}</script>
    })

  const renderNonScripts = renderSnippets.filter(tag => tag.type !== "script")

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={generatePageTitle(
        showSiteTitleInPageTitle,
        siteTitleLocationInPageTitle,
        siteTitle
      )}
      meta={[
        {
          name: `keywords`,
          content: keywords,
        },
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: image,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: image,
        },
        {
          name: `twitter:creator`,
          content: author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ].concat(meta)}
    >
      <link
        rel="shortcut icon"
        type="image/x-icon"
        href={favicon?.url || "favicon-9.12.2023.png"}
      />
      {!!canonicalLink && <link rel="canonical" href={canonicalLink} />}
      {renderNonScripts}
      {renderScripts}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
